import { render, staticRenderFns } from "./ZddRecord.vue?vue&type=template&id=10b783cc&scoped=true"
import script from "./ZddRecord.vue?vue&type=script&lang=js"
export * from "./ZddRecord.vue?vue&type=script&lang=js"
import style0 from "./ZddRecord.vue?vue&type=style&index=0&id=10b783cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b783cc",
  null
  
)

export default component.exports